module.exports = __webpack_public_path__ + "media/images/roundedRectangle3cop_11-a1eb9c01d74b9e10f042512249b52d10.png";